__turbopack_context__.v({
  "dropIn": "LoadingState-module__jGBFgq__dropIn",
  "foodItem": "LoadingState-module__jGBFgq__foodItem",
});
